module.exports = __webpack_public_path__ + "img/platum.2a70882b.png";